import PropTypes from "prop-types";

import Tooltip from "@mui/material/Tooltip";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

const statColumns = [
  { label: "Completes", key: "complete" },
  { label: "Terminate", key: "terminate" },
  { label: "Quota Full", key: "quota_full" },
  { label: "Security Terminate", key: "security_terminate" },
  { label: "Partial", key: "initiate" },
];

const statCount = (stats, key) => Number(stats?.[key] || 0);

function StatsHoverCard({ label, stats = {} }) {
  const columns = statColumns.map((column) => ({
    ...column,
    count: statCount(stats, column.key),
  }));
  const total = columns.reduce((sum, column) => sum + column.count, 0);
  const displayColumns = [...columns, { label: "Total", key: "total", count: total }];

  return (
    <SoftBox
      sx={{
        minWidth: 540,
        p: 1,
        color: "#1e293b",
        backgroundColor: "#fde047",
        borderRadius: "6px",
      }}
    >
      <SoftTypography variant="caption" fontWeight="regular" color="dark" sx={{ fontSize: "12px" }}>
        {label}
      </SoftTypography>
      <SoftBox
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(6, minmax(72px, 1fr))",
          mt: 0.75,
          borderTop: "1px solid rgba(15, 23, 42, 0.2)",
          borderLeft: "1px solid rgba(15, 23, 42, 0.2)",
        }}
      >
        {displayColumns.map((column) => (
          <SoftBox
            key={`${column.key}-heading`}
            sx={{
              px: 0.5,
              py: 0.45,
              textAlign: "center",
              borderRight: "1px solid rgba(15, 23, 42, 0.2)",
              borderBottom: "1px solid rgba(15, 23, 42, 0.2)",
              fontSize: "10px",
              fontWeight: column.key === "total" ? 700 : 400,
              whiteSpace: "normal",
              lineHeight: 1.15,
            }}
          >
            {column.label}
          </SoftBox>
        ))}
        {displayColumns.map((column) => (
          <SoftBox
            key={`${column.key}-count`}
            sx={{
              px: 0.5,
              py: 0.55,
              textAlign: "center",
              borderRight: "1px solid rgba(15, 23, 42, 0.2)",
              borderBottom: "1px solid rgba(15, 23, 42, 0.2)",
              fontSize: "11px",
              fontWeight: column.key === "total" ? 700 : 400,
            }}
          >
            {column.count}
          </SoftBox>
        ))}
      </SoftBox>
    </SoftBox>
  );
}

StatsHoverCard.propTypes = {
  label: PropTypes.string.isRequired,
  stats: PropTypes.object,
};

function StatsHoverTooltip({ label, stats = {}, children }) {
  return (
    <Tooltip
      placement="bottom"
      componentsProps={{
        tooltip: {
          sx: {
            p: 0,
            maxWidth: "none",
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        },
      }}
      title={<StatsHoverCard label={label} stats={stats} />}
    >
      <SoftBox
        component="span"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: 17,
          cursor: "help",
        }}
      >
        {children}
      </SoftBox>
    </Tooltip>
  );
}

StatsHoverTooltip.propTypes = {
  label: PropTypes.string.isRequired,
  stats: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default StatsHoverTooltip;
